module.exports = __webpack_public_path__ + "img/postarole.4a4e53a5.png";